module.exports = __webpack_public_path__ + "static/media/it-audit.6bd663ef.png";